module.exports = __webpack_public_path__ + "img/DOCUMENT.7887ac48.svg";